var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploaded-photo-item",class:{'sm': _vm.small}},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.imageData,"alt":""}})]),_c('small',{staticClass:"title"},[_vm._v(_vm._s(_vm.imageType.replace('-', ' '))+" photo")])])
}
var staticRenderFns = []

export { render, staticRenderFns }